














import Vue from 'vue'
import { Component, Prop } from 'vue-property-decorator'
import { CoursePurchaseInvoice } from '../../../api/v2/models/course_purchase'
import { format } from 'date-fns'

@Component({})
export default class CoursePurchaseInvoiceComponent extends Vue {
  @Prop({ required: true })
  coursePurchaseInvoice: CoursePurchaseInvoice

  get date() {
    return format(this.coursePurchaseInvoice.paiedAt, 'YYYY/MM/DD')
  }
}
